import { useEffect, useState } from "react";
import { Nav } from "react-bootstrap";
import { NavLink, useParams } from "react-router-dom";

const API_BASE = (process.env.REACT_APP_API_URL || "").replace(/\/+$/, "");

function pickCover(post) {
  // 1) Featured image via _embedded.wp:featuredmedia
  const media = post?._embedded?.["wp:featuredmedia"]?.[0];
  const sized =
    media?.media_details?.sizes?.large?.source_url ||
    media?.media_details?.sizes?.medium_large?.source_url ||
    media?.media_details?.sizes?.medium?.source_url ||
    media?.source_url;
  if (sized) {
    return {
      url: sized,
      alt:
        media?.alt_text ||
        post?.title?.rendered?.replace(/<[^>]+>/g, "") ||
        "Cover image",
    };
  }

  // 2) First <img> inside content
  const html = post?.content?.rendered || "";
  const m =
    html.match(/<img[^>]+src="([^"]+)"[^>]*alt="([^"]*)"/i) ||
    html.match(/<img[^>]+src="([^"]+)"/i);
  if (m) return { url: m[1], alt: (m[2] || "").trim() || "Cover image" };

  return { url: "", alt: "" };
}

export default function BlogPost() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [err, setErr] = useState("");

  useEffect(() => {
    (async () => {
      try {
        const q = `/posts?slug=${encodeURIComponent(slug)}&_embed=1`;
        const r = await fetch(`${API_BASE}/wp_proxy.php?q=${encodeURIComponent(q)}`, { cache: "no-store" });
        if (!r.ok) throw new Error(`HTTP ${r.status}`);
        const arr = await r.json();
        if (!Array.isArray(arr) || !arr.length) throw new Error("Not found");
        // Debug: ensure _embedded is present here
        console.log("Post payload:", arr[0]);
        setPost(arr[0]);
      } catch (e) {
        setErr(String(e?.message || e));
      }
    })();
  }, [slug]);

  if (err) return <p className="p-10 text-center text-red-600">❌ {err}</p>;
  if (!post) return <p className="p-10 text-center opacity-70">Loading…</p>;

  const cover = pickCover(post);
  console.log("Resolved cover:", cover);

  return (
    <article className="max-w-3xl mx-auto px-6 py-10">
      <NavLink to="/blog" className="text-sm text-indigo-600 hover:underline mb-6 inline-block">
        ← Back to Blog
      </NavLink>
      {/* Featured image (with graceful fallback) */}
      {cover.url && (
        <img
          src={cover.url}
          alt={cover.alt}
          className="w-full aspect-[16/9] object-cover rounded-2xl mb-8 shadow-sm"
          loading="eager"
        />
      )}

      {/* Title + date */}
      <h1
        className="text-3xl font-bold mb-2"
        dangerouslySetInnerHTML={{ __html: post.title?.rendered || "" }}
      />
      <div className="text-sm opacity-70 mb-6">
        {post.date ? new Date(post.date).toLocaleDateString() : ""}
      </div>

      {/* WP HTML body */}
      <div
        className="wp-content prose prose-lg max-w-none"
        dangerouslySetInnerHTML={{ __html: post.content?.rendered || "" }}
      />
    </article>
  );
}
